import BlockRegistry from '../../BlockRegistry';

const stripQuotes = (str) => {
    if (typeof str === 'string' && str.startsWith('"') && str.endsWith('"')) {
        return str.slice(1, -1);
    }
    return str;
};

export function registerUltrasonicSensor() {
    BlockRegistry.register('ultrasonicSensor_ultrasonic_readDistance', (block, context) => {
        let trig = context.getInputValue(block, 'TRIG');
        let echo = context.getInputValue(block, 'ECHO');
        
        trig = stripQuotes(trig);
        echo = stripQuotes(echo);
        
        context.addSetup(`pinMode(${trig}, OUTPUT);`);
        context.addSetup(`pinMode(${echo}, INPUT);`);
        
        context.addHelper('readUltrasonic', `
float readUltrasonic(int trigPin, int echoPin) {
    digitalWrite(trigPin, LOW);
    delayMicroseconds(2);
    digitalWrite(trigPin, HIGH);
    delayMicroseconds(10);
    digitalWrite(trigPin, LOW);
    long duration = pulseIn(echoPin, HIGH);
    return duration * 0.034 / 2;
}`.trim());

        return `readUltrasonic(${trig}, ${echo})`;
    });

    BlockRegistry.registerPython('ultrasonicSensor_ultrasonic_readDistance', (block, context) => {
        let trig = context.getInputValue(block, 'TRIG');
        let echo = context.getInputValue(block, 'ECHO');
        
        trig = stripQuotes(trig);
        echo = stripQuotes(echo);
        
        context.addInclude('from machine import Pin\nimport time');
        context.addSetup(`pin_${trig} = Pin(${trig}, Pin.OUT)`);
        context.addSetup(`pin_${echo} = Pin(${echo}, Pin.IN)`);
        
        context.addHelper('ultrasonic_read', `
def ultrasonic_read(t, e):
    pin_t = Pin(t, Pin.OUT)
    pin_e = Pin(e, Pin.IN)
    pin_t.low()
    time.sleep_us(2)
    pin_t.high()
    time.sleep_us(5)
    pin_t.low()
    while pin_e.value() == 0:
        signaloff = time.ticks_us()
    while pin_e.value() == 1:
        signalon = time.ticks_us()
    timepassed = signalon - signaloff
    return (timepassed * 0.0343) / 2`.trim());

        return `ultrasonic_read(${trig}, ${echo})`;
    });
}
